'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react-dom/15.2.0/react-dom/index.js
 ** module id = 38
 ** module chunks = 0
 **/